import styled from "styled-components";

export const TimePickerContainer = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  .custom-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .text-error {
    color: #ff4d4f;
    font-size: 12px;
    margin-top: 4px;
    font-weight: normal;
  }

  .react-time-picker {
    display: inline-flex;
    width: 100%;
    position: relative;

    &__wrapper {
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
      border: 1px solid #F5F5F5;
      border-radius: 10px;
      padding: 17px 12px;
      background: #fff;
      transition: all 0.3s;
      background-color: #F5F5F5;

      &:hover {
        border-color: #4096ff;
      }

      &:focus-within {
        border-color: #4096ff;
        box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
        outline: 0;
      }
    }

    &__inputGroup {
      min-width: calc((4px * 3) + 0.54em * 6 + 0.217em * 2);
      flex-grow: 1;
      padding: 0 2px;
      box-sizing: content-box;


      &__input {
        min-width: 0.54em;
        height: 20px;
        position: relative;
        padding: 0;
        border: 0;
        background: none;
        color: #333;
        font-size: 14px;
        font-family: inherit;
        box-sizing: content-box;
        -webkit-appearance: textfield;
        

        &:focus {
          outline: none;
        }

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      &__divider {
        padding: 0 2px;
      }
    }

    &__button {
      display: none;
    }

    &__clock {
      display: none !important;
    }
  }
`;